<div class="content">
  <h3 class="title1">¡Un momento!</h3>
  <p class="title2">
    Ten en cuenta que estás adquiriendo un producto en preventa y tu pedido no saldrá de nuestras instalaciones hasta
    contar con él en nuestro almacén. La fecha de venta es el {{ releaseDate }}. Además te informamos de que una vez
    realizado el pago, el pedido no podrá cancelarse.
  </p>
  <p class="title2">
    Ante cualquier problema o consulta no dudes en ponerte en contacto con nuestro equipo de atención al cliente a
    través del chat.
  </p>
  <ion-item lines="none">
    <ion-label>
      <span
        >Entiendo y acepto que al contener un producto en preventa, el plazo de entrega habitual de mi pedido se verá
        afectado.
      </span>
    </ion-label>
    <ion-checkbox (ionChange)="changeCheck()" slot="start"></ion-checkbox>
  </ion-item>
  <div class="buttons-div">
    <ion-button color="medium-dark" class="title2" (click)="closeModal(false)">Volver atrás</ion-button>
    <ion-button color="primary" [disabled]="!check" class="title2" (click)="closeModal(true)">Entendido</ion-button>
  </div>
</div>
